import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import {
	DisabledInteractiveWrapperComponent
} from './disabled-interactive-wrapper/disabled-interactive-wrapper.component';

export * from './disabled-interactive.directive';
export * from './disabled-interactive.module';
export * from './disabled-interactive-wrapper/disabled-interactive-wrapper.component';

export const NgxDisabledInteractiveModule = angular.module('NgxDisabledInteractiveModule', [])
	.directive('disabledInteractiveWrapper', downgradeComponent({ component: DisabledInteractiveWrapperComponent }))
	.name;
